export const SEASON_VOLUME_COLUMNS_WIDTH = 120;
export const VOLUME_OTHER_COLUMNS_WIDTH = 85;
export const SEASON_COST_COLUMNS_WIDTH = 140;
export const VOLUME_COLUMNS_WIDTH = 120;
export const COST_COLUMNS_WIDTH = 155;

export const STYLES_FOR_CELL_WITH_WRAP = {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 5px',
    lineHeight: '20px',
    wordBreak: 'break-word',
};

export const totalCostTooltipText =
    'Стоимость всего в текущем уровне цен (с учетом прочих и лимитированных затрат), руб. без НДС';
export const totalCostText = 'Стоимость всего, руб. без НДС';

export const unitCostText = 'Стоимость единицы в текущем уровне цен, руб. без НДС';
export const unitCostTooltipText =
    'Стоимость единицы в текущем уровне цен (с учетом прочих и лимитированных затрат), руб. без НДС';

export const excludeTitleModalTitle = 'Подтверждение Исключения';
export const excludeTitleModalConfirmText = 'Вы уверены, что хотите исключить записи из Изм. к НЗ?';
export const removeTitleModalTitle = 'Подтверждение удаления';
export const removeTitleModalConfirmText = 'Вы уверены, что хотите удалить записи?';
export const excludeTitleModalConfirmBtnText = 'Исключить';
export const excludeTitleModalCancelBtnText = 'Не исключать';
